import { IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';
import '../../../styles/templates/customers/account.scss';

if (IS_NATIVE_APP_CLIENT) {
  var notificationBlock = document.querySelector('div.notification-block');
  if (notificationBlock) {
    notificationBlock.classList.add('webview');
  }
}
